import axios from 'axios';
import {
  ImpersonateRequest,
  ImpersonateResponse,
  ImpersonationExchangeResponse,
  ImpersonationExitResponse,
} from '@repo/types';
import { $api } from './base';

const host = import.meta.env.VITE_BACKEND_HOST;

export const impersonateAdminUser = async (
  userId: number,
  payload?: ImpersonateRequest,
): Promise<ImpersonateResponse> => {
  const response = await $api.post(
    `/api/admin/users/${userId}/impersonate/`,
    payload ?? {},
  );
  return response.data;
};

export const cancelActiveImpersonation = async (): Promise<void> => {
  await $api.post('/api/admin/users/impersonation/cancel-active/');
};

export const exchangeImpersonationGrant = async (
  grant: string,
): Promise<ImpersonationExchangeResponse> => {
  const response = await axios.post(`${host}/api/auth/impersonation/exchange`, {
    grant,
  });
  return response.data;
};

export const exitImpersonation = async (
  refresh: string,
): Promise<ImpersonationExitResponse> => {
  const response = await $api.post('/api/auth/impersonation/exit', {
    refresh,
  });
  return response.data;
};
